import React from 'react'

export const CollaborateHome = () => {
  return <div>CollaborateHome</div>;
}

